<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header">
                        <strong> In Scan Out Scan Details</strong> 
                    </div>

                    <div>
                        <b-row>
                            <b-col md="10">
                                <b-row>
                                    <b-col>
                                        <!-- {{ selectDateFrom }} -->
                                        <b-form-group label="From Date:"  :label-cols="4" >
                                            <v-date-picker mode='single' input-class="dateInput"
                                            :available-dates='{ start: null, end: new Date() }'
                                            v-model='selectDateFrom'>
                                        </v-date-picker>
                                        </b-form-group>
                                    </b-col>

                                    <b-col>
                                        <b-form-group label="To Date:"  :label-cols="3">
                                            <v-date-picker mode='single' input-class="dateInput" 
                                            :available-dates='{ start: selectDateFrom, end: null }' v-model='selectDateTo'>
                                            </v-date-picker>
                                        </b-form-group>
                                    </b-col>
                                    
                                    <b-col>
                                        <b-form-group label="Select Hub"
                                        :label-cols="4">
                                            <b-form-select  v-model="selectedhub">
                                                <option :value="select">-- Select Hub --</option>
                                                <option :value="hub.hubid" v-for="hub in hubItems"  :key="hub.hubid" >
                                                    {{hub.hubname}} - {{hub.hubid}}
                                                </option>
                                                
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>            
                            </b-col>

                            <b-col md="2">
                                <b-button :disabled="selectedhub.length == 0 && selectDateFrom.length==0 && selectDateTo.length==0" @click="searchhub()"  size="md" variant="primary">Search</b-button>
                                &nbsp;
                                <b-button :disabled="selectedhub.length == 0 && selectDateFrom.length==0 && selectDateTo.length==0" @click="clearSearch()"    size="md" variant="danger">Clear</b-button>
                            </b-col>

                            <b-col md="5">
                              <b-form-group label="Selected Date : " :label-cols="3">
                                <b-form-radio-group v-model="selected_date" class="mt-1">
                                  <b-form-radio value="dispatch_date">Dispatch Date</b-form-radio>
                                  <b-form-radio value="hubinscan_date">Hubinscan Date</b-form-radio>
                                </b-form-radio-group>
                              </b-form-group>
                            </b-col>

                            <b-col md="4">
                              <b-form-group label="Status" :label-cols="3">
                                <b-form-select  v-model="selected_status">
                                  <option :value="select_st">-- Select Status --</option>
                                  <!-- <option :value="status.shipmentstatus" v-for="status in statusitem"  :key="status.shipmentstatus" >
                                  {{status.shipmentstatus}}
                                </option> -->
                                <option value="Delivered">Delivered</option>
                                <option value="DispatchOutScan">DispatchOutScan</option>
                                <option value="InTransit">InTransit</option>
                                <option value="OFD">OFD</option>
                                <option value="ZoneInScan">ZoneInScan</option>
                                
                                                
                                 </b-form-select>
                              </b-form-group>
                                <!-- <select class="form-control" v-model="selected_status">
                                  <option value=""> Select Option </option>
                                  <option :value="statusitem"></option>
                                </select>
                              </b-form-group> -->
                            </b-col>

                            <b-col md="2">
                              <div class="text-right" v-if="selected_status!=''">
                                    <a  :href="downlaodScanurl+'usertype='+UserName+'&sysusermasterid='+SysUser+'&hub_id='+selectedhub+'&startdate='+fromatstartdate+'&enddate='+formatenddateto+'&date_category='+selected_date+'&status='+selected_status" target="_blank"><b-button v-b-tooltip.hover title="Download Reports" variant="primary" :disabled="totalRows == 0">Download</b-button>
                                    </a>
                                </div>
                                <div class="text-right" v-else>
                                    <a  :href="downlaodScanurl+'usertype='+UserName+'&sysusermasterid='+SysUser+'&hub_id='+selectedhub+'&startdate='+fromatstartdate+'&enddate='+formatenddateto+'&date_category='+selected_date" target="_blank"><b-button v-b-tooltip.hover title="Download Reports" variant="primary" :disabled="totalRows == 0">Download</b-button>
                                    </a>
                                </div>
                            </b-col>
                        </b-row>
                    </div>

                    <div class="text-right mt-3">
                        <b>Total Records : <strong style="color: red;">{{totalRows}}</strong></b>
                    </div>

                    <b-row>
                        <b-col md="12">
                            <b-table show-empty responsive  :items="hubscanlist" :busy="isBusy" :fields="fields" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div> 
                                <template slot="loadid" slot-scope="row">
                                    {{row.item.loadid}}
                                    <br>
                                    <br>
                                      <span v-if="row.item.defective_boxes>0 " class="badge " style="background-color:rgb(235 113 100);color:white;font-size: 13px;padding:6px;padding-top: 4px;"   >Defective Count :  {{ row.item.defective_boxes }}</span>
                                    </template> 
                                
                                <template slot="noofboxes" slot-scope="row">
                                    <button v-b-tooltip.hover title="View Count Details" @click="BoxDetails(row.item)" style="background-color:white !important;" class="btn btn-link" >
                                          <span style="color:#1b8eb7"> {{row.item.noofboxes}} </span>
                                    </button>
                                </template> 
                              </b-table>  
                        </b-col>
                    </b-row>

                    <b-modal size="lg" title="MPS Count Details" v-model="boxdetailsmodal" @ok="boxdetailsmodal = false" hide-footer>
        
                        <template slot="default" slot-scope="{ hide }">
                        <b-row>
                        <b-col sm="12" class="text-right">
                          <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
                        </b-col>   
                        <div style="float: left;">
                            <!-- v-if="this.mpstotalRows > 0" -->
                            <span class="badge ml-2" 
                            style="background-color:rgb(192, 57, 43); color: white;font-size: 13px; padding: 5px 5px 5px;">DB</span> Damage Box&nbsp;&nbsp;
                          </div>
                        <b-col sm="12"> 
                          <!-- <b-col sm="12"> -->
                        <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusyMps" >
                          <div slot="table-busy" class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                            </div> 
                            <template slot="shippingid" slot-scope="row">
                                <span>{{row.item.shippingid}}</span>
                                <br>
                                <span v-if="row.item.is_defective=='YES'" class="badge " style="background-color:#c0392b;color:white;font-size: 13px;padding:6px;padding-top: 4px;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">DB</span>
                              </template> 
                          <template slot="mpsvalue" slot-scope="row">
                                  <span>{{row.item.mpsvalue}}</span>
                                </template>
                                <template slot="physicalweight" slot-scope="row">
                                  <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                                </template>
                                <template slot="breadth" slot-scope="row">
                                  <span> {{row.item.breadth}} {{row.item.lbhunit}}</span>
                                </template>
                                <template slot="length" slot-scope="row">
                                  <span> {{row.item.length}} {{row.item.lbhunit}}</span>
                                </template>
                                <template slot="height" slot-scope="row">
                                  <span> {{row.item.height}} {{row.item.lbhunit}}</span>
                                </template>
                                <template slot="deliverystatus" slot-scope="row">
                                  <span v-if="row.item.deliverystatus=='INTransit'" style="color: red;"> {{row.item.deliverystatus}} </span>
                                  <span v-else> {{row.item.deliverystatus}} </span>
                                </template>
                                <template slot="shipmentstatus" slot-scope="row">
                                  <span v-if="row.item.deliverystatus=='INTransit'" style="color: red;">{{row.item.shipmentstatus}} </span>
                                  <span v-else>{{row.item.shipmentstatus}}</span>
                                </template>
                              
                        </b-table> 
                      <!-- </b-col> -->
                      </b-col>
                      </b-row> 
                        <b-row>
                        <b-col md="6" class="my-1" v-if="mpstotalRows>10">
                          <b-pagination
                                v-model="mpscurrentPage"
                                :total-rows="mpstotalRows"
                                :per-page="mpsperPage"
                                class="my-0"
                              ></b-pagination>
                      
                        </b-col> 
                      </b-row>
                          <div class="col-md-12 pull-right"> 
                                  <div slot="footer" class="text-right">
                                  
                                    <b-button  size="sm" variant="danger" @click="detailsCancel()">Close</b-button>
                                  </div>
                                </div>
                        </template>
                        <template slot="modal-footer" slot-scope="{ cancel }">
                          <b-button size="sm" variant="danger" @click="detailsCancel()" style="display:none">
                            Cancel
                          </b-button>
                        </template>
                    </b-modal>

                    <b-modal size="md" id="defective_image_modal" title="Defective Image" hide-footer>
                        <div v-if="selected_user_details.defective_imageurl==null" class="text-center">
                          No Record Found
                        </div>
                        <div v-else class="text-center">
                          <img :src="selected_user_details.defective_imageurl" width="100%" height="100%" />
                        </div>
                      </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
    data() {
        return {
            hubscanlist :[],
            fields : [
                { key : 'parentawb', label :'Parent AWB', sortable: true},
                { key : 'loadid', label :'Load ID', sortable: true},
                { key : 'zoneinscandate', label :'Zone In Scan Date', sortable: true},
                { key : 'zoneoutscandate', label :'Zone Out Scan Date', sortable: true},
                { key : 'noofboxes', label :'NO. Of Boxes', sortable: true},
                { key : 'origin_city', label :'Origin City', sortable: true},
                { key : 'dest_city', label :'Destination City', sortable: true},
                { key : 'loadstatus', label :'Load Status', sortable: true},
            ],
            totalRows :0,
            mpsitems:[],
            mpstotalRows :'',
            mpsfields:[
                { key: 'shippingid', label: 'MPS No', sortable: true, sortDirection: 'desc' },
                { key: 'mpsvalue', label: 'MPS Value', sortable: true, sortDirection: 'desc' },
                
                { key: 'length', label: 'Length', sortable: true, sortDirection: 'desc' },
                { key: 'breadth', label: 'Breadth', sortable: true, sortDirection: 'desc' },
                
                { key: 'height', label: 'Height', sortable: true, sortDirection: 'desc' },
                { key: 'physicalweight', label: 'Physical Weight', sortable: true, sortDirection: 'desc' },
                { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc' },
                { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
                
            ],
            isBusy : false,
            downlaodScanurl :'',
            UserName:'',
            SysUser :'',
            Userhubid:'',
            boxdetailsmodal :false,
            // selectDateFrom :'',
            // selectDateTo :'',
            selectDateFrom: new Date(),
            selectDateTo:new Date(),
            isBusyMps:false,
            mpstotalRows: 0,
            mpscurrentPage: 1,
            mpsperPage: 10,
            hubItems:[],
            selectedhub:'',
            select :'',
            selectedhubvalue :'',
            fromatstartdate :'',
            formatenddateto :'',
            selected_user_details :'',
            selected_date :'dispatch_date', 
            selected_status :'',
            select_st :'',
            statusitem :[],
            statusObj:{}
        }
    },
    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        // console.log("userInfo",userInfo)
        this.UserName= userInfo.user_type;
        this.SysUser= userInfo.sysusermasterid;
        this.Userhubid = userInfo.hub_id;
        
        const INScanOutScanurl = `${CONSTANTS.MIGRATION_API_URL}/getCSVForInscanOutscanShipment?`
        this.downlaodScanurl=INScanOutScanurl;
        this.hubListing();
        // this.statusListing();
        this.getscandetailsList();

        
    },
    methods: {

        getscandetailsList :function(){
            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var starttoday = this.selectDateFrom;
            // Current Date
            this.fromatstartdate = starttoday.getFullYear()+'-'+(starttoday.getMonth()+1)+'-'+starttoday.getDate();
            console.log("startdate",this.fromatstartdate);

            var endtoday = this.selectDateTo;
            // End Date
            this.formatenddateto = endtoday.getFullYear()+'-'+(endtoday.getMonth()+1)+'-'+endtoday.getDate();
            console.log("date",this.formatenddateto)
            console.log("this.selected_status",typeof this.selected_status);
          if(this.selected_status!=''){
            this.statusObj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`,
                // hub_id:userInfo.user_type!=1?`${userInfo.hub_id}`:"",
                hub_id:`${this.selectedhub}`,   
                startdate: `${this.fromatstartdate}`,
                enddate:`${this.formatenddateto}`,
                date_category : `${this.selected_date}`,
                status : `${this.selected_status}`
            }
          }else{
            this.statusObj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`,
                // hub_id:userInfo.user_type!=1?`${userInfo.hub_id}`:"",
                hub_id:`${this.selectedhub}`,   
                startdate: `${this.fromatstartdate}`,
                enddate:`${this.formatenddateto}`,
                date_category : `${this.selected_date}`,
                // status : `${this.selected_status}`
            }
          }
            let obj=this.statusObj;
            console.log("ibject",obj)
            // return false
            this.$http
                .post(
                    `${ CONSTANTS.MIGRATION_API_URL}/getHubInScanOutscanDetailReport`,obj).then(result => {
                    this.isBusy=false;
                    // console.log("result",result)
                    if (result.body.returnmsg === "Successful") {
                        // alert("ok")
                    this.hubscanlist=result.body.returnvalue;
                    this.totalRows=result.body.returnvalue.length;
                    }else{
                        this.hubscanlist=[];
                        this.totalRows=0;
                    }
                    }).catch(ex => {
                    console.log("error", ex);
                });
        },


        hubListing(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype : `${userInfo.user_type}`,
        }
        console.log("objlist",obj)
        this.$http
              .post(
                `${ CONSTANTS.MIGRATION_API_URL}/getAllHubListing`,obj).then(result => {
                  if (result.body.returnmsg === "Successful") {
                   this.hubItems=result.body.returnvalue;
                   console.log("aaaaaaaa",this.hubItems);
                   
                  }else{
                    this.hubItems=[];
                  }
                }).catch(ex => {
                console.log("error", ex);
              });
        },

        searchhub (){
            let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData);
            this.selectedhub=this.selectedhub;
            console.log("sssssss",this.selectedhub)
            this.getscandetailsList();
        },

        clearSearch(){
            this.selectedhub ='';
            this.selected_status = '';
            this.selectDateFrom= new Date();
            this.selectDateTo=new Date();
            this.getscandetailsList();
        },

         // open models

        BoxDetails:function(value){
            this.mpscurrentPage=1;
            this.boxdetailsmodal=true;
            this.isBusyMps = true;
            let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData);
    
            let obj = {
                parentawb: value.parentawb,
            }
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`,obj)
                .then(result => {
                    this.isBusyMps = false;
                    if(result.body.returnmsg === "successful"){
                    
                    this.mpsitems  = result.body.returnvalue;
                    this.mpstotalRows = result.body.returnvalue.length;
                    
                    }else {
                    this.mpsitems  = [];
                    this.mpstotalRows = 0
                    }
                }).catch(ex => {
                console.log('error', ex)
            })
            
        },

        detailsCancel : function () {
            this.boxdetailsmodal=false;
        },

        Viewimagedetails : function (data){
            this.selected_user_details=data;
            console.log("rrrrrrrrrrr",this.selected_user_details);
        },

        statusListing(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={}
        console.log("objlist",obj)
        this.$http
              .post(
                `${ CONSTANTS.MIGRATION_API_URL}/getDistinctShipmentStatus`,obj).then(result => {
                  if (result.body.returnmsg === "Successful") {
                   this.statusitem=result.body.returnvalue;
                   console.log("aaaaaaaa",this.statusitem);
                   
                  }else{
                    this.statusitem=[];
                  }
                }).catch(ex => {
                console.log("error", ex);
              });
        },

    },
}
</script>

<style>

</style>